import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  constructor() {}

  canActivate(): true | Promise<boolean> {
    return true;
  }
}

export const QrCodeGuard: CanActivateFn = (): true | Promise<boolean> => {
  return inject(PermissionsService).canActivate();
};
